<template>
  <div>
    <Header />

    <div class="main">
      <Contents />
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Footer from "../../components/layout/Footer.vue";
import Contents from "./components/Contents.vue";
export default {
  components: {
    Header,
    Footer,
    Contents,
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  margin-bottom: 30px;
}

h4 {
  text-align: center;
  color: #052333;
  font-weight: bold;
}
</style>
